import { Link as RouterLink, useSearchParams, useNavigate } from 'react-router-dom';
import { m } from 'framer-motion';
import { useEffect, useState } from 'react';
// @mui
import { Alert, Tooltip, Stack, Typography, Link, Box } from '@mui/material';
// auth
import { useAuthContext } from '../../context-state/AuthContext';
// routes
import { PATH_AUTH } from '../../routes/paths';
// layouts
import AuthLayout from '../../layouts/auth';
//
import AuthLoginForm from './AuthLoginForm';
import AuthWithSocial from './AuthWithSocial';
import { useLocales } from "../../locales";
import {MotionContainer, varFade} from "../../components/minimal/animate";

// ----------------------------------------------------------------------

export default function Login() {

    const { translate } = useLocales();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [showInactivityAlert, setShowInactivityAlert] = useState(false);

    // Check if user was logged out due to inactivity
    useEffect(() => {
      const reason = searchParams.get('reason');
      if (reason === 'inactivity') {
        setShowInactivityAlert(true);
      }
    }, [searchParams]);

    // Handle dismissing inactivity alert
    const handleDismissAlert = () => {
      setShowInactivityAlert(false);
      // Remove the 'reason' query parameter from URL
      navigate('/auth/login', { replace: true });
    };

  return (
    <AuthLayout title={translate('auth.login_title')}>

      <Stack component={MotionContainer} spacing={2} sx={{ mb: 5, position: 'relative' }}>

          <m.div variants={varFade().in}>
            <Typography variant="h4">{translate('auth.login')}</Typography>
          </m.div>
          <m.div variants={varFade().in}>
            <Stack direction="row" spacing={0.5}>
            </Stack>
          </m.div>
      </Stack>


      {/* Inactivity logout notification */}
      {showInactivityAlert && (
        <Alert
          severity="info"
          sx={{ mb: 3 }}
          onClose={handleDismissAlert}
        >
          {translate('inactivity.logged_out_message')}
        </Alert>
      )}

        <AuthLoginForm />

        {/*<m.div variants={varFade().in}>*/}
        {/*    <AuthWithSocial />*/}
        {/*</m.div>*/}
    </AuthLayout>
  );
}
